import React from 'react';

import Select from 'components/shared/Select/Select';

import { addressFormats, currencyFormats, dateFormats, nameFormatOptions } from '../lib/constants';

const getHint = (headerValue, patientDetailsFormat) => {
  switch (headerValue?.value) {
    case 'dob':
      return !patientDetailsFormat?.dobFormat?.value ? 'Please select a DOB format' : null;
    case 'name':
      return !patientDetailsFormat?.patientName?.value ? 'Please select Name format' : null;
    case 'insurance_policy_start_date':
      return !patientDetailsFormat?.policyStartDateFormat?.value
        ? 'Please select PSD format'
        : null;
    case 'insurance_policy_end_date':
      return !patientDetailsFormat?.policyEndDateFormat?.value ? 'Please select PED format' : null;
    case 'appointment_provider':
      return !patientDetailsFormat?.providerName?.value ? 'Please select Name format' : null;
    case 'transaction_amount':
      return !patientDetailsFormat?.transactionAmountFormat?.value
        ? 'Please select a currency format'
        : null;
    case 'transaction_amount_paid_self':
      return !patientDetailsFormat?.transactionAmountSelfFormat?.value
        ? 'Please select a currency format'
        : null;
    default:
      return headerValue?.message || '';
  }
};

const ImportSelectItem = ({
  headerValue,
  patientDetailsFormat,
  columnHeaderOptions,
  onChangeHandler,
  handleHeaderSelect,
  index,
  refs
}) => (
  <div style={{ minWidth: '12rem' }}>
    {getHint(headerValue, patientDetailsFormat) && (
      <span className="m-1 rounded-md border-none bg-danger-200 p-1.5 text-black">
        {getHint(headerValue, patientDetailsFormat)}
      </span>
    )}
    <div className="flex flex-col gap-2">
      <Select
        isClearable
        options={columnHeaderOptions}
        onChange={(e) => handleHeaderSelect(e, index)}
        value={headerValue || null}
      />
      {headerValue?.value === 'full_street_address' && (
        <Select
          isClearable
          value={patientDetailsFormat?.addressFormat}
          options={addressFormats}
          onChange={(e) => onChangeHandler(e, 'addressFormat', refs.addressFormatRef, index)}
          placeholder="Type how address appears in the table"
          required
        />
      )}
      {headerValue?.value === 'dob' && (
        <Select
          isClearable
          value={patientDetailsFormat?.dobFormat}
          options={dateFormats}
          onChange={(e) => onChangeHandler(e, 'dobFormat', refs.dobFormatRef, index)}
          placeholder="Type how birthday appears in the table"
          required
        />
      )}
      {headerValue?.value === 'name' && (
        <Select
          isClearable
          value={patientDetailsFormat?.patientName}
          options={nameFormatOptions}
          onChange={(e) => onChangeHandler(e, 'patientName', refs.nameFormatRef, index)}
          placeholder="Please enter order of name in the field"
          required
        />
      )}
      {headerValue?.value === 'insurance_policy_start_date' && (
        <Select
          isClearable
          value={patientDetailsFormat?.policyStartDateFormat}
          options={dateFormats}
          onChange={(e) =>
            onChangeHandler(e, 'policyStartDateFormat', refs.policyStartDateFormatRef, index)
          }
          placeholder="Type how policy start date appears in the table"
          required
        />
      )}
      {headerValue?.value === 'insurance_policy_end_date' && (
        <Select
          isClearable
          value={patientDetailsFormat?.policyEndDateFormat}
          options={dateFormats}
          onChange={(e) =>
            onChangeHandler(e, 'policyEndDateFormat', refs.policyEndDateFormatRef, index)
          }
          placeholder="Type how policy end date appears in the table"
          required
        />
      )}
      {headerValue?.value === 'appointment_provider' && (
        <Select
          isClearable
          value={patientDetailsFormat?.providerName}
          options={nameFormatOptions}
          onChange={(e) => onChangeHandler(e, 'providerName', refs.providerNameFormatRef, index)}
          placeholder="Please enter order of name in the field"
          required
        />
      )}
      {headerValue?.value === 'transaction_amount' && (
        <Select
          isClearable
          value={patientDetailsFormat?.transactionAmountFormat}
          options={currencyFormats}
          onChange={(e) =>
            onChangeHandler(e, 'transactionAmountFormat', refs.transactionAmountFormatRef, index)
          }
          placeholder="Please enter currency format"
          required
        />
      )}
      {headerValue?.value === 'transaction_amount_paid_self' && (
        <Select
          isClearable
          value={patientDetailsFormat?.transactionAmountSelfFormat}
          options={currencyFormats}
          onChange={(e) =>
            onChangeHandler(
              e,
              'transactionAmountSelfFormat',
              refs.transactionAmountSelfFormatRef,
              index
            )
          }
          placeholder="Please enter currency format"
          required
        />
      )}
    </div>
  </div>
);

export default ImportSelectItem;
